/**
 * Force complete logout and clear all auth data
 * Use this to ensure a fresh login with updated token structure
 */
export const forceCompleteLogout = () => {
  console.log('🔄 Forcing complete logout...');
  
  // Clear all possible auth-related items from localStorage
  const itemsToClear = [
    'token',
    'user',
    'user_id',
    'client_id',
    'isAdmin',
    'isClientAdmin',
    'userId',
    'clientId',
    'role',
    'permissions'
  ];
  
  itemsToClear.forEach(item => {
    if (localStorage.getItem(item)) {
      console.log(`  Clearing localStorage.${item}`);
      localStorage.removeItem(item);
    }
  });
  
  // Clear any session storage as well
  sessionStorage.clear();
  
  console.log('✅ All auth data cleared. Redirecting to login...');
  
  // Force reload to login page
  window.location.href = '/';
};

// Make it available globally for console use
if (typeof window !== 'undefined') {
  window.forceLogout = forceCompleteLogout;
}